module.exports = __webpack_public_path__ + "76f7eab965c238d1ea781e9224d1e253.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/slideshow_05_mobile.jpg
// module id = 656
// module chunks = 0